<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">热处理报告</p>
        <p class="sn" @click="alterInputClick('reportNo','报告编号')">
          报告编号：<span>{{ value.reportNo }}</span>
        </p>
        <table class="p1">
          <tr>
            <td width="20%"><p>产品编号</p></td>
            <td colspan="3">
              <p>{{ value.pronum }}</p>
            </td>
          </tr>
          <tr>
            <td><p>产品总数量</p></td>
            <td width="30%">
              <p>{{ value.amount }}</p>
            </td>
            <td width="20%"><p @click="alterInputClick('heatType','热处理方法')">热处理方法</p></td>
            <td width="30%" @click="alterInputClick('heatType','热处理方法')">
              <p>{{ value.heatType }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('volume','产品规格')">产品规格</p></td>
            <td @click="alterInputClick('volume','产品规格')">
              <p>{{ value.volume }}</p>
            </td>
            <td><p @click="alterInputClick('heatNo','热处理炉号')">热处理炉号</p></td>
            <td @click="alterInputClick('heatNo','热处理炉号')">
              <p>{{ value.heatNo }}</p>
            </td>
            
          </tr>
          <tr>
            <td><p @click="alterInputClick('matnum','材料入库编号')">材料入库编号</p></td>
            <td @click="alterInputClick('matnum','材料入库编号')">
              <p>{{ value.matnum }}</p>
            </td>
            <td><p @click="alterInputClick('grade','材质')">材质、钢管规格</p></td>
            <td @click="alterInputClick('spec','钢管规格')">
              <p>{{ value.grade }}|{{value.spec}}</p>
            </td>
           
          </tr>
          <tr>
            <td><p @click="alterInputClick('sampleNo','随炉试样编号')">随炉试样编号</p></td>
            <td @click="alterInputClick('sampleNo','随炉试样编号')">
              <p>{{ value.sampleNo }}</p>
            </td>
            <td><p @click="alterInputClick('equipNo','热处理炉型号')">热处理炉型号</p></td>
            <td @click="alterInputClick('equipNo','热处理炉型号')">
              <p>{{ value.equipNo }}</p>
            </td>
    
          </tr>
        </table>
          <table class=p2>
            <tr>
              <td colspan="7"><p>热处理工艺要求</p></td>
            </tr>
            <tr>
              <td width="15%"><p>工艺步骤</p></td>
              <td><p>入炉温度（℃）</p></td>
              <td><p>升温速度（℃）</p></td>
              <td><p>保温温度（℃）</p></td>
              <td><p>保温时间</p></td>
              <td><p>冷却速度或介质（℃/s）</p></td>
              <td width="15%"><p>操作者</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('name1','入炉温度（℃）')"><p>{{value.name1}}</p></td>
              <td @click="alterInputClick('t1z1','升温速度（℃）')"><p>{{value.t1z1}}</p></td>
              <td @click="alterInputClick('t1z2','保温温度（℃）')"><p>{{value.t1z2}}</p></td>
              <td @click="alterInputClick('t1z3','保温温度（℃）')"><p>{{value.t1z3}}</p></td>
              <td @click="alterInputClick('t1z4','保温时间')"><p>{{value.t1z4}}</p></td>
              <td @click="alterInputClick('t1z5','冷却速度或介质')"><p>{{value.t1z5}}</p></td>
              <td rowspan="3" @click="alterInputClick('operator','操作者姓名')"><p>{{value.operator}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('name2','入炉温度（℃）')"><p>{{value.name2}}</p></td>
              <td @click="alterInputClick('t2z1','升温速度（℃）')"><p>{{value.t2z1}}</p></td>
              <td @click="alterInputClick('t2z2','保温温度（℃）')"><p>{{value.t2z2}}</p></td>
              <td @click="alterInputClick('t2z3','保温温度（℃）')"><p>{{value.t2z3}}</p></td>
              <td @click="alterInputClick('t2z4','保温时间')"><p>{{value.t2z4}}</p></td>
              <td @click="alterInputClick('t2z5','冷却速度或介质')"><p>{{value.t2z5}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('name3','入炉温度（℃）')"><p>{{value.name3}}</p></td>
              <td @click="alterInputClick('t3z1','升温速度（℃）')"><p>{{value.t3z1}}</p></td>
              <td @click="alterInputClick('t3z2','保温温度（℃）')"><p>{{value.t3z2}}</p></td>
              <td @click="alterInputClick('t3z3','保温温度（℃）')"><p>{{value.t3z3}}</p></td>
              <td @click="alterInputClick('t3z4','保温时间')"><p>{{value.t3z4}}</p></td>
              <td @click="alterInputClick('t3z5','冷却速度或介质')"><p>{{value.t3z5}}</p></td>
            </tr>
          </table>
        <div class="p3">
          <p class="sign-title">实际热处理温度— — 时间记录曲线：</p>
          <p class="float-temp1-1 ft" @click="alterInputClick('floatTemp1z1','报告编号')">{{value.floatTemp1z1}}</p>
          <p class="float-temp1-2 ft" @click="alterInputClick('floatTemp1z2','报告编号')">{{value.floatTemp1z2}}</p>
          <p class="float-temp2-1 ft" @click="alterInputClick('floatTemp2z1','入炉温度')">{{value.floatTemp2z1}}</p>
          <p class="float-temp2-2 ft" @click="alterInputClick('floatTemp2z2','淬火温度')">{{value.floatTemp2z2}}</p>
          <p class="float-temp2-3 ft" @click="alterInputClick('floatTemp2z3','回火温度')">{{value.floatTemp2z3}}</p>
          <p class="float-time2-1 ft" @click="alterInputClick('floatTime2z1','淬火保温时间')">{{value.floatTime2z1}}</p>
          <p class="float-time2-2 ft" @click="alterInputClick('floatTime2z2','回火保温时间')">{{value.floatTime2z2}}</p>
          <img :src="img1[value.heatType]" alt="" style="height:120pt;"/>
          <p>
            附：热处理-时间自动记录曲线图
          </p>
        </div>
        <div class="p4">
          <p class="sign-title" @click="alterSelectClick('sign1','检测签名')">热处理责任人：<span class="sign-img"><img :src="urlTrans(value.sign1)" alt="" style="width:90pt;height:34pt;"></span></p>
          <p class="stamp">（盖章）</p>
          <p class="date" @click="alterInputClick('reportDate','报告日期','date')"> 日期：{{value.reportDate}}</p>
        </div>
        <p class="page">第1页 共1页</p>
      </div>
    </div>
    </div>

    <Modal v-model="modalValue.alterValue" :width="1000" :mask-closable="false">
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "heatReport",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      value: {},
      pronumList:[],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      fid: 0,
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: {'正火':process.env.BASE_URL + "img/heat1.jpg",'调质':process.env.BASE_URL + "img/heat2.jpg",}
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "signatureList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "normalReport",
          enid: this.fileId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.value = response.data.content;
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

.content p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p {
  line-height: 14pt !important;
}

.free-text {
  text-align: left;
  padding: 3pt 10pt;
}

.underline {
  display: inline-block;
  width: 80pt;
  border-bottom: 1px solid #333;
  line-height: 14pt;
  text-align: center;
}

.w1 {
  border: 1px solid #333;
  padding: 10pt;
}

.sub-title {
  margin-top: 30pt;
  text-align: center;
  font-size: 16pt !important;
  font-weight: 600;
  margin-bottom: 10pt;
}

.sign {
  margin-top: 10pt;
  text-align: right;
}

.p1,
.p2,
.p3,
.w1,
.p4,
.p5 {
  border: 1px solid #333;
}

.p1 td {
  padding: 9pt 0;
}

.p1 p {
  line-height: 1.2;
}

.s-line {
  position: relative;
  bottom: 0.5pt;
}

.sign-span {
  margin-right: 100pt;
  position: relative;
}

.sign-img {
  position: absolute;
  left: 100pt;
  top: 10pt;
  z-index: 10;
}

.sign-item {
  position: absolute;
  left: 50pt;
  white-space: nowrap;
}

.date-span {
  margin-right: 60pt;
  position: relative;
}

.date-item {
  position: absolute;
  left: 30pt;
  white-space: nowrap;
}

.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

input {
  border: none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}

table.p2 td{
  height:28pt;
}

table.p2 td p{
  line-height: 1.2;
}

.p3 {
  border-top:none;
  border-bottom: none;
}


div.p3,div.p4{
  padding: 2pt 10pt;
  position: relative;
}



.sign-title {
  text-align: left;
  position: relative;
}

.sign-mark {
  text-align: right;
}

.result {
  text-align: left;
  text-indent: 24pt;
}

table.p5 td {
  padding: 0pt 0;
  height:24pt;
}

.page {
  text-align: right;
  color: #999;
  padding-top: 5pt;
  padding-right: 5pt;
}

.float-temp1-1{
  top:50pt;
  left:212pt;
}

.float-temp1-2{
  top:35pt;
  left:278pt;
  
}

.float-temp2-1{
  top:70pt;
  left:105pt;
}

.float-temp2-2{
  top:50pt;
  left:175pt;
}

.float-temp2-3{
  top:60pt;
  left:335pt;
}

.float-time2-1{
  top:115pt;
  left:185pt;
}

.float-time2-2{
  top:115pt;
  left:345pt;
}
.ft{
  position: absolute;
  font-size: 13pt !important;
}

.stamp{
  margin-top:20pt;
  text-align: right;
  padding-right:100pt;
}

.date{
  text-align: right;
  padding-right:60pt;
}
</style>